export default __webpack_public_path__ + "static/media/background.30c73b88.png";